import React from "react";
import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { MdDelete } from "react-icons/md";
import { useFormik } from "formik";
import { CInput } from "../common";
import { cocDeleteRequestSchema } from "../../utils/schemas";

export default function DeleteCOCModal({ data, onDelete }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const formik = useFormik({
    initialValues: {
      coc: data._id,
      status: "pending",
      comment: "",
    },
    validationSchema: cocDeleteRequestSchema,
    onSubmit: (values) => {
      onDelete(values);
      onClose();
    },
  });

  return (
    <>
      <Tooltip label="Delete COC">
        <IconButton
          icon={<MdDelete />}
          bgColor="red.100"
          color="red.500"
          fontSize="xl"
          isRound
          onClick={onOpen}
        />
      </Tooltip>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Order Deletion Request</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CInput
              type="textarea"
              label="Comment"
              name="comment"
              placeholder="Enter Comment"
              value={formik.values.comment}
              onChange={formik.handleChange}
              errors={formik.errors.comment}
              touched={formik.touched.comment}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              type="submit"
              onClick={formik.handleSubmit}
              isLoading={formik.isSubmitting}
              loadingText="sending..."
              bgColor="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
              me="2"
            >
              Send Request
            </Button>
            <Button
              onClick={() => onClose()}
              bgColor="gray.200"
              color="black"
              borderRadius="lg"
              fontWeight="medium"
              py="6"
              px="7"
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
